<template>
  <div>
    <b-row>
      <b-col class="text-center">
        <b-form inline class="d-inline-block">
          <b-form-input
            v-model="form.input.value"
            placeholder="Search"
            size="sm"
            @keyup.enter.native="activateSearch"
          />
          <b-form-select
            class="ml-2 mr-2"
            v-model="form.select.value"
            :options="form.select.options"
            size="sm"
          />

          <b-button
            variant="anchor"
            size="sm"
            :disabled="!Boolean(form.input.value)"
            @click="activateSearch"
          >
            Submit
          </b-button>
        </b-form>
      </b-col>
    </b-row>
    <hr/>
    <loans-infinite-table
      v-if="search.active"
      group="all"
      :search-key="search.key"
      :search-value="search.value"
      @total-loans-set="total => $emit('count-updated', total)"
      @total-amount-set="total => $emit('amount-updated', total)"
    />
  </div>
</template>


<script>
import LoansInfiniteTable from '@/components/my_deals/deals/LoansInfiniteTable';


export default {
  components: {
    LoansInfiniteTable,
  },
  data: () => ({
    search: {
      key: null,
      value: null,
      active: false,
    },
    form: {
      select: {
        options: {
          address: 'Address',
          number: 'Number',
        },
        value: 'address',
      },
      input: {
        value: null,
      },
    },
  }),
  methods: {
    activateSearch() {
      if (!this.form.input.value) { return; }

      this.search.active = false;
      this.$nextTick(() => {
        this.search = {
          key: this.form.select.value,
          value: this.form.input.value,
          active: true,
        };
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/deals/LoanSearch.vue